import '../product/InspectionFormSheet.css';

interface Props {
  authorName?: string | null;
  reviewerName?: string | null;
  approverName?: string | null;
}

/** 결재 문서 공통 작성/검토/승인 도장란 */
function ApprovalStampBox({ authorName, reviewerName, approverName }: Props) {
  return (
    <div className="ifs-sheet__stamps">
      {(
        [
          ['작성', authorName],
          ['검토', reviewerName],
          ['승인', approverName],
        ] as const
      ).map(([label, value]) => (
        <div key={label}>
          <strong>{label}</strong>
          <span style={{ color: value ? '#1f2a37' : '#98a2b3', fontWeight: value ? 600 : 400 }}>
            {value || '-'}
          </span>
        </div>
      ))}
    </div>
  );
}

export default ApprovalStampBox;
